import React, { useEffect, useRef } from 'react';

import {
    Animated,
    Easing,
    Platform,
    StyleProp,
    View,
    ViewStyle,
} from 'react-native';

import { useSelector } from 'react-redux';

import { selectLayoutConfig } from 'store/config/selectors';

import Spinner from './spinner';
import styles from './styles';

type Props = {
    color?: string;
    size?: number;
    duration?: number;
    style?: StyleProp<ViewStyle>;
    testID?: string;
    routeKey: string;
};

const LoadingCircle = ({
    color,
    size = 48,
    duration = 1200,
    style,
    testID,
    routeKey,
}: Props) => {
    const animatedValue = useRef(new Animated.Value(0));
    const rotate = animatedValue.current.interpolate({
        inputRange: [0, 1],
        outputRange: ['0deg', '360deg'],
    });

    const { primary } = useSelector(selectLayoutConfig);

    const doAnimation = () => {
        Animated.loop(
            Animated.timing(animatedValue.current, {
                toValue: 1,
                duration,
                useNativeDriver: Platform.OS !== 'web',
                easing: Easing.linear,
            }),
        ).start();
    };

    const renderCircle = (transform: any) => (
        <Animated.View testID={testID} style={[{ transform }]}>
            <Spinner
                color={color || primary || '#D13D39'}
                height={size}
                width={size}
                routeKey={routeKey}
            />
        </Animated.View>
    );

    useEffect(() => {
        doAnimation();
        return () => {
            if (animatedValue.current) {
                animatedValue.current.removeAllListeners();
            }
        };
    }, []);

    return (
        <View style={[styles.container, style]}>
            {renderCircle([{ rotate }])}
        </View>
    );
};

export default LoadingCircle;
